import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.teacher.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.teacher.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.teacher.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.teacher.update(id), data);
  },
  changePassword(id, password) {
    let passData = { password: password };
    return BackendAPI('put', ApiRoutes.teacher.changePassword(id), passData);
  },
  frozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.teacher.frozen(id), data);
  },
  tamaiClasses(id, data = {}) {
    return BackendAPI('get', ApiRoutes.teacher.tamaiClasses(id), data);
  },
  validateId(id) {
    return BackendAPI('get', ApiRoutes.teacher.validateId(id));
  },
};
